module.exports = __webpack_public_path__ + "static/media/empty-emails.cfc091c3.svg";